// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".canvas_contents[data-v-3ee672ef]{width:100%;height:100%;overflow:hidden}", ""]);
// Exports
module.exports = exports;
